
import XHeader from 'vux/src/components/x-header/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import {fetch,promptMessage } from '../../api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
export default {
data(){
return {
chooseIf:false,
noembryoIf:false,
radioList:[]

}
},
components:{
XHeader,Radio ,XButton,Group
},
methods:{
EmbryoList(sfzh){
fetch('post',urlConfig.myEmbryoGetList +'?sfzh='+sfzh+'&gzhArea='+this.hosCode).then(response => {

if(response.length == 0){
this.chooseIf = false;
this.noembryoIf = true;
}else {
this.chooseIf = true;
this.noembryoIf = false;
this.radioList = response;
this.radioList[0].checked = true;
this.chargeId = this.radioList[0].CHARGEID;
this.sysid = this.radioList[0].SYSID;
this.dqrq = this.radioList[0].DQRQ;
this.patientId = this.radioList[0].PATIENTID;
if(this.paramsTxt == '胚胎续冻费一年'){
this.months = 12;
}else {
this.months = 6;
}
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
})
},
renew(){
this.$router.push({path: 'integralMallDetail', query: {openid:this.$route.query.openid,chargeId:this.chargeId, sysid:this.sysid, dqrq:this.dqrq, patientId:this.patientId,months:this.months, title:this.paramsTxt,personInfoId:this.$route.query.personInfoId,sfzh:this.$route.query.sfzh,Mypoints:this.$route.query.Mypoints,xm:this.$route.query.xm,sign:this.$route.query.sign,hosCode:this.hosCode}});
}, //下一步
information(obj){
this.chargeId = obj.CHARGEID;
this.sysid = obj.SYSID;
this.dqrq =obj.DQRQ;
this.patientId = obj.PATIENTID;
},  //选择续费哪条信息
},
mounted(){
this.paramsTxt = this.$route.query.txt;
this.hosCode = this.$route.query.hosCode;
this.EmbryoList(this.$route.query.sfzh);
}
}



// WEBPACK FOOTER //
// ./src/project/integralMallProject/integraMallEmbryo.vue